import React, { useEffect, useState, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import CommonCrypt from './Common/CommonCrypt';
import { useParams } from 'react-router-dom';
import Header from './Header/Header';
import Banner from './Banner/Banner';
const Footer = React.lazy(() => import('./Footer/Footer'));
import InnerBanner from './InnerBanner/InnerBanner';
import Component from './Components';
import Contacts from './elements/contactSection/Contacts';
import ThankYouPage from './elements/thankyou/ThankYou';
import EventCalendar from './elements/EventCalender/EventCalender';
import EventCalenderDetail from './elements/EventCalender/EventCalenderDetail';
import NotFoundPage from './error/404';
import AccessDenied from './error/accessdenied';
import SiteMap from './SiteMap/SiteMap';
import NewsDetails from './elements/newsSection/NewsDetails';
import AttractionsDetails from './elements/attractionsSection/AttractionsDetails';
import PhotoAlbumDetail from './elements/PhotoAlbum/PhotoAlbumDetail';
import SearchResult from './elements/SearchResult/SearchResult';
import DPLForm from './DPL/DPLForm';
import ComingSoon from './elements/ComingSoon';
import Loader from './Loader';

function Home() {
    const  route  = useParams();
    const APP_URL = window.site_url;
    const [Pagedata,setPagedata] = useState([]);
    const [HeaderMenudata,setHeaderMenudata] = useState([]);
    const [SiteLogosData,setSiteLogos] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [notFound, setnotFound] = useState(false);
    useEffect(()=>{
        setIsLoading(true);
        const data = {
            'slug' : route.route ? route.route : 'home',
            'detailSlug': route.slug ? route.slug : ''
        }
        const fetChData = async () =>{
            if(route.route == 'discounts'){
                document.body.classList.add('disc-page');
            } else {
                document.body.classList.remove('disc-page');
            }
            const response = await fetch(APP_URL + '/api/home',{
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
              });
            const home_data = await response.json();
            const homeDecrypted = JSON.parse(CommonCrypt(home_data.home_result))
            if (route?.route === 'accessdenied') {
                setnotFound(false); // Ensure it does not trigger 404
            } else if (homeDecrypted.status && homeDecrypted.status == 404){
                setnotFound(true);
            }else{
                setnotFound(false);
            }
            setIsLoading(false);
            setPagedata(homeDecrypted);
        };
        fetChData();
    },[route]);

    useEffect(()=>{
        const fetChData = async () =>{
            const response = await fetch(APP_URL + '/api/header-menu',{
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json',
                },
              });
            const header_menu_data = await response.json();
            const header_menuDecrypted = JSON.parse(CommonCrypt(header_menu_data.header_menu_result))
            setHeaderMenudata(header_menuDecrypted);
            // svgIcon();
        };

        fetChData();
    },[route]);

    useEffect(()=>{
        const fetChData = async () =>{
            const response = await fetch(APP_URL + '/api/logo-image',{
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json',
                },
              });

              const site_logos_data = await response.json();
              setSiteLogos(site_logos_data);
        };

        fetChData();
    },[]);

    if (isLoading) {
        return <div></div>;
    }
    if (route?.route === 'accessdenied') {
    return (
        <>
            <Header menuObj={HeaderMenudata?.menuArr} FrontLogo={SiteLogosData?.site_logos?.menu_logo} FrontStickyLogo={SiteLogosData?.site_logos?.sticky_footer_logo} Constant={HeaderMenudata?.constants} />
            <InnerBanner InnerBanner={Pagedata?.inner_Banner} Pagedata={Pagedata?.data} Breadcrumbs={Pagedata?.breadcrumbs}Constant={HeaderMenudata?.constants} />
            <AccessDenied />
            <Footer Constant={HeaderMenudata?.constants} FrontFooterLogo={SiteLogosData?.site_logos?.footer_logo} FrontGovLogo={SiteLogosData?.site_logos?.gov_logo} menuArrFooter={HeaderMenudata?.menuArrFooter} menuArrFooterBottom={HeaderMenudata?.menuArrFooterBottom} />
        </>
    );
}

    if(notFound){
        return (
        <>
            <Header menuObj={ HeaderMenudata?.menuArr } FrontLogo = {SiteLogosData?.site_logos?.menu_logo} FrontStickyLogo = {SiteLogosData?.site_logos?.sticky_footer_logo} Constant = {HeaderMenudata?.constants}/>
            <InnerBanner InnerBanner={Pagedata?.inner_Banner} Pagedata={Pagedata?.data} Breadcrumbs = {Pagedata?.breadcrumbs} Constant = {HeaderMenudata?.constants}/>
            <NotFoundPage />
            <Footer Constant = {HeaderMenudata?.constants} FrontFooterLogo = {SiteLogosData?.site_logos?.footer_logo} FrontGovLogo = {SiteLogosData?.site_logos?.gov_logo} menuArrFooter = {HeaderMenudata?.menuArrFooter} menuArrFooterBottom = {HeaderMenudata?.menuArrFooterBottom}/>
        </>);
    }

    const Components = () => {
        switch (Pagedata?.constants?.MODULE?.NAME) {  // Ensure `route` is defined before accessing `route.route`
            case 'contact-us':
                return <Contacts PageData={Pagedata?.data} ContactInfo={Pagedata?.ConatctInfo} alias={route} Constant={Pagedata?.constants} />;
                break;
                case 'eventcalendar':
                    if(Pagedata?.record_detail){
                        return (Pagedata?.data) ? <EventCalenderDetail PageData={Pagedata?.data} DetailRecord = {Pagedata?.record_detail} ContactInfo={Pagedata?.ConatctInfo} alias={route} Constant={Pagedata?.constants}/> : <NotFoundPage />;
                    }else{
                    // console.log(Pagedata.data);
                    return <EventCalendar PageData={Pagedata?.data} ContactInfo={Pagedata?.ConatctInfo} alias={route} Constant={Pagedata?.constants} />;
                }
                break;
            case 'news':
                if(Pagedata?.record_detail){
                    return (Pagedata?.data) ? <NewsDetails PageData={Pagedata?.data} DetailRecord = {Pagedata?.record_detail} Constant={Pagedata?.constants}/> : <NotFoundPage />;
                } else {
                    return <Component PageData={Pagedata?.data} ContactInfo={Pagedata?.ConatctInfo} alias={route} Constant={Pagedata?.constants} />;
                }
                break;
            case 'photo-album':
                if(Pagedata?.record_detail){
                    return (Pagedata?.data) ? <PhotoAlbumDetail PageData={Pagedata?.data} DetailRecord = {Pagedata?.record_detail} Constant={Pagedata?.constants}/> : <NotFoundPage />;
                }
            case 'attractions':
                if(Pagedata?.record_detail){
                    return (Pagedata?.data) ? <AttractionsDetails PageData={Pagedata?.data} DetailRecord = {Pagedata?.record_detail} Constant={Pagedata?.constants}/> : <NotFoundPage />;
                } else {
                    return <Component PageData={Pagedata?.data} ContactInfo={Pagedata?.ConatctInfo} alias={route} Constant={Pagedata?.constants} />;
                }
                break;
            default:
                // console.log(Pagedata.data.txtDescription);
                if(route?.route=='thank-you'){
                    return <ThankYouPage PageData={Pagedata?.data} ContactInfo={Pagedata?.ConatctInfo} alias={route} Constant={Pagedata?.constants} />;
                } else if (route?.route=='sitemap'){
                    return <SiteMap PageData={Pagedata?.data} alias={route} Constant={Pagedata?.constants} />;
                }else if(route?.route == 'search'){
                    return <SearchResult/>
                } else {
                    if(Pagedata.data?.txtDescription){
                        return <Component PageData={Pagedata?.data} ContactInfo={Pagedata?.ConatctInfo} alias={route} Constant={Pagedata?.constants} />;
                    } else {
                        return <ComingSoon PageData={Pagedata?.data} alias={route} />;
                    }
                }
                break;
        }
    };
    const logoUrl = SiteLogosData?.site_logos?.sticky_footer_logo?.image;
    const fullLogoUrl = logoUrl?.startsWith('http') ? logoUrl : APP_URL + logoUrl;
        return (
            <>
                <Helmet>
                    <title>{Pagedata?.data?.varMetaTitle}</title>
                    <meta name="title" content={Pagedata?.data?.varMetaTitle} />
                    <meta name="description" content={Pagedata?.data?.varMetaDescription} />
                    <link rel="canonical" href={`${APP_URL}/${route.route || ''}/${route.slug || ''}`} />

                    {/* Facebook OG */}
                    <meta property="og:title" content={Pagedata?.data?.varMetaTitle} />
                    <meta property="og:description" content={Pagedata?.data?.varMetaDescription} />
                    <meta property="og:image" content={fullLogoUrl} />
                    <meta property="og:url" content={window.location.href} />
                    <meta property="og:type" content="website" />

                    {/* Twitter */}
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:title" content={Pagedata?.data?.varMetaTitle} />
                    <meta name="twitter:description" content={Pagedata?.data?.varMetaDescription} />
                    <meta name="twitter:image" content={fullLogoUrl} />
                    <meta name="twitter:url" content={window.location.href} />
                </Helmet>

                <div id="wrapper">
                        {route?.route !== 'data-removal' ? (
                            <>
                            {/* <Loader/> */}
                            <Header menuObj={ HeaderMenudata?.menuArr } FrontLogo = {SiteLogosData?.site_logos?.menu_logo} FrontStickyLogo = {SiteLogosData?.site_logos?.sticky_footer_logo} Constant = {Pagedata?.constants}/>
                            {
                                (route.route && route.route != 'home') ? (Pagedata?.constants && Pagedata?.constants?.MODULE.NAME == 'attractions' && route.slug) ? '' : <InnerBanner InnerBanner={Pagedata?.inner_Banner} Pagedata={Pagedata?.data} Breadcrumbs = {Pagedata?.breadcrumbs} Constant = {HeaderMenudata?.constants}/>
                                :  <Banner BannerArr= {Pagedata?.home_banner} />
                            }
                            {
                                (route?.route=='thank-you' || route?.route=='search') ? <Components/> : (Pagedata?.data) ? <Components/> : (<NotFoundPage/>)
                            }
                            <Footer Constant = {Pagedata?.constants} FrontFooterLogo = {SiteLogosData?.site_logos?.footer_logo} FrontGovLogo = {SiteLogosData?.site_logos?.gov_logo} menuArrFooter = {HeaderMenudata?.menuArrFooter} menuArrFooterBottom = {HeaderMenudata?.menuArrFooterBottom}/>
                            </>

                        ) : <DPLForm FrontLogo = {SiteLogosData?.site_logos?.footer_logo} Constant={Pagedata?.constants} defaultEmail={Pagedata?.DefaultDataRemovalEmail}/> }
                </div>
            </>
    );
}

export default Home;
